export default "__VITE_ASSET__193bf74b__"